import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface HeroImageProps {
  src: string;
  alt: string;
  className?: string;
  overlay?: string;
  children?: React.ReactNode;
}

export const HeroImage = ({
  src,
  alt,
  className,
  overlay = "bg-gradient-to-r from-black/70 via-black/50 to-black/40",
  children,
}: HeroImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState<string>("");

  useEffect(() => {
    // For LCP optimization, set image immediately since it's preloaded
    setImageSrc(src);
    setIsLoaded(true);
  }, [src]);

  return (
    <section 
      className={cn(
        "relative overflow-hidden min-h-[50vh] flex items-center",
        className
      )}
    >
      {/* Background image with optimization */}
      <div 
        className={cn(
          "absolute inset-0 transition-opacity duration-500",
          isLoaded ? "opacity-100" : "opacity-0"
        )}
        style={{
          backgroundImage: imageSrc ? `url('${imageSrc}')` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Loading state */}
      {!isLoaded && (
        <div className="absolute inset-0 bg-muted animate-pulse" />
      )}

      {/* Overlay */}
      <div className={cn("absolute inset-0", overlay)} />

      {/* Content */}
      <div className="container mx-auto max-w-6xl relative z-10">
        {children}
      </div>
    </section>
  );
};